import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function DocumentList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasdoctypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdoctypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "DC_Id", label: "#" },
    { field: "DC_Name", label: "Document Type" },
    { field: "DC_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasdoctypeEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.DC_Id));

        navigate(
          `/DocumentLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/DocChecklist/list`}
      actions={actions}
      title={`Document Type`}
      {...(hasdoctypeAddprivilege(privilegeData) && {
        linkvalue: `/DocumentLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default DocumentList;
